import { createContext, useContext } from 'react';

import type { ReadCandidatesResponseType } from '../api/candidate-api';

export type SidebarPanel = 'search' | 'aiSearch';

export type AiSearchContextType = {
  isActive: boolean;
  isLoading: boolean;
  searchText: string;
  results: ReadCandidatesResponseType | null;
  error: string | null;
  activePanel: SidebarPanel;
  setActivePanel: (panel: SidebarPanel) => void;
  search: (text: string) => void;
  cancelSearch: () => void;
};

export const AiSearchContextProvider =
  createContext<AiSearchContextType | null>(null);

export const useAiSearch = (): AiSearchContextType => {
  const context = useContext(AiSearchContextProvider);
  if (!context) {
    throw new Error('useAiSearch must be used within an AiSearchProvider');
  }
  return context;
};
